// Breakfast
const breakfast = {
  cbhBenny: "/images/menu/cbh-benny.jpg",
  bananaNutWaffle: "/images/menu/banananut-waffle.jpg",
  pancakes: "/images/menu/pancakes.jpg",
  chxSteak: "/images/menu/chx-steak.jpg",
  omlette: "/images/menu/omlette.jpg",
};

// Specials
const specials = {};

// Other
const other = {
  ownerPhoto: "/images/owner-photo.png",
};

export { breakfast, other };
